import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=794e705c"
import script from "./DeviceSettings.vue?vue&type=script&lang=ts"
export * from "./DeviceSettings.vue?vue&type=script&lang=ts"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&id=794e705c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports